// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Div, H2, P, Span } from 'common/styles/oc-styled-components';

import { colors, FONT_FAMILIES } from 'common/styles/style-constants';

import RatingStars from '../RatingStars/RatingStars';

import { formatAverageRating } from '../../helpers/common-helpers';

import { AlignReviews, RatingValue, RatingWrapper } from './styled-components';

// Other

// Component
const RatingLarge = ({
  averageRating,
  reviewsCount,
  sourcesCount,
  profileReviews,
  textAlign,
  inlineRatingStars,
}) => (
  <AlignReviews textAlign={textAlign} className="rating-large">
    <RatingWrapper inline={inlineRatingStars}>
      <div aria-hidden>
        <RatingValue inline={inlineRatingStars}>
          {formatAverageRating(averageRating)}
        </RatingValue>
        <Span
          color={colors.ash}
          display="inline"
          fontWeight="300"
          fontSize="22px"
          fontFamily={FONT_FAMILIES.circular}
        >
          /5
        </Span>
      </div>
      <Div margin={inlineRatingStars ? '0 0 7px 12px' : '0 0 5px 0'}>
        <RatingStars averageRating={averageRating} sideLength="30px" />
      </Div>
    </RatingWrapper>
    {profileReviews
      ?       (
        <H2 margin="0" aria-label="Average Customer Reviews">
          Avg. Customer Reviews
        </H2>
      )
      : null}
    <P color={colors.slate} fontSize={profileReviews ? '16px' : '14px'}>
      {reviewsCount} Reviews{' '}
      {sourcesCount !== undefined
        && `from ${sourcesCount} source${sourcesCount !== 1 ? 's' : ''}`}
    </P>
  </AlignReviews>
);

RatingLarge.propTypes = {
  averageRating: PropTypes.number,
  reviewsCount: PropTypes.number,
  profileReviews: PropTypes.string,
  textAlign: PropTypes.string,
  inlineRatingStars: PropTypes.bool,
  sourcesCount: PropTypes.number,
};

export default RatingLarge;
